module.exports = __webpack_public_path__ + "img/12.1e23df4c.png";